export function emptyWaveSaveStateMeta() {
    return {
        pendingOutboundCount: 0,
        lastAckAt: null,
        lastError: null,
    };
}
export function waveSaveStateLabel(state) {
    switch (state) {
        case "syncing":
            return "Salvataggio…";
        case "synced":
            return "Salvato";
        case "pending":
            return "In attesa rete";
        case "error":
            return "Errore salvataggio";
    }
}
